import React, { useState } from 'react';
import pin from '../../Pages/Worldmap/SVG/pin.svg';
import { detectDistrict } from '../../Utils/districtUtils';

const styles = {
  container: {
    padding: '16px',
    borderBottom: '1px solid #e5e7eb'
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    textAlign: 'left',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    transition: 'color 0.2s ease',
    filter: 'none',
  },
  text: {
    fontSize: '14px',
    fontWeight: 400,
    transition: 'color 0.2s ease',
  },
  icon: {
    width: '16px',
    height: '16px',
    transition: 'filter 0.2s ease',
  }
};

const AddressComponent = ({ properties }) => {
  const [isHovered, setIsHovered] = useState(false);
  const district = detectDistrict(properties.adresse);

  const getGoogleMapsUrl = (address) => {
    const encodedAddress = encodeURIComponent(address);
    return `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
  };

  const handleAddressClick = (address) => {
    window.open(getGoogleMapsUrl(address), '_blank');
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const renderAddress = () => (
    properties.adresse && (
      <div style={styles.container}>
        {district && (
          <div style={{
            display: 'inline-block',
            backgroundColor: district.color,
            color: 'white',
            padding: '4px 12px',
            borderRadius: '16px',
            fontSize: '10px',
            fontWeight: '600',
            marginBottom: '8px',
            letterSpacing: '0.8px',
            textTransform: 'uppercase',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
          }}>
            {district.displayName}
          </div>
        )}
        <button
          onClick={() => handleAddressClick(properties.adresse)}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={styles.button}
        >
          <img
            src={pin}
            alt="Location Pin"
            style={{
              ...styles.icon,
              filter: isHovered ? 'invert(43%) sepia(97%) saturate(1645%) hue-rotate(204deg) brightness(99%) contrast(96%)' : 'none'
            }}
          />
          <span style={{
            ...styles.text,
            color: isHovered ? '#2563eb' : '#000000'
          }}>
            {properties.adresse}
          </span>
        </button>
      </div>
    )
  );

  return renderAddress();
};

export default AddressComponent;